<div class="inputcontainer {{container_class}}">
	<select id="{{id}}"
	        [(ngModel)]="ref_object[property]"
			[disabled]="disabled"
			[class.wijzigbaar]="wijzigbaar"
			class="pr-4"
			(change)="change($event)">
			<option *ngIf="!verplicht" [value]="''" [selected]="ref_object[property] == ''"></option>
			<option *ngFor="let option of _opties" [value]="option[optionValueProperty]" [selected]="option[optionValueProperty] == ref_object[property]">
				{{option[optionLabelProperty]}}
			</option>
	</select> 
</div>